import React from 'react';
import moment from 'moment';
import { Table, Column } from '@tencent/spaui';

export const NoticeCenterInHeader = React.memo((props) => {
  const { list } = props;
  const goToNoticeCenter = () => {
    window.location.hash = '/message/index';
  };

  const onClick = (noticeId, version) => {
    let currentHash = '';
    if (location.hash.indexOf('#/message') == -1 || location.hash == '#/message') {
      // 不在消息中心页面中或者在消息中心默认页面
      currentHash = '#message/index';
    } else {
      currentHash = location.hash;
    }
    location.hash = `${currentHash}/${noticeId}/${version}`;

    const item = list.find((item) => item.noticeId === noticeId);
    if (item) {
      item.isRead = true;
      props.updateNoticeList([...list]);
    }
  };

  const columnRender = (type, name, value, data) => {
    let result = '';
    if (type != 'head') {
      switch (name) {
        case 'categoryName':
          result = (
            <div className="categroy-name-text">
              {data.isRead ? <span className="base-dot gray" /> : <span className="base-dot blue" />}
              <span>{value}</span>
            </div>
          );
          break;
        case 'updateTime': {
          const date = moment(value).format('YYYY-MM-DD');
          result = <span>{date}</span>;
          break;
        }
        case 'title':
          result = <span onClick={() => onClick(data.noticeId, data.version)}>{value}</span>;
          break;
        default:
          result = value;
          break;
      }
    } else {
      result = value;
    }
    return result;
  };
  return (
    <ul className="spaui-topnav-menu notice-center">
      <div className="datalist">
        <div className="description">消息中心</div>
        <Table hideThead data={list} className="datalist" emptyText="暂无未读消息">
          <Column name="categoryName" maxWidth="60" render={columnRender} dataClassName="categoryName"></Column>
          <Column name="title" maxWidth="400" render={columnRender} dataClassName="title"></Column>
          <Column name="updateTime" maxWidth={60} render={columnRender} dataClassName="updateTime"></Column>
        </Table>
        <div className="more-notice">
          <a
            href="javascript:void(0)"
            onClick={() => {
              goToNoticeCenter();
            }}
          >
            查看更多消息
          </a>
        </div>
      </div>
    </ul>
  );
});
